<button type="button"
        [class]="containerClass()"
        [disabled]="isDisabled()"
        [matTooltip]="size() === 'small' ? tooltip() : ''"
        matTooltipPosition="above"
        (click)="onClick($event)">

  <span class="xls-btn-icon-wrap">
    @if (loading()) {
      <mat-spinner [diameter]="spinnerSize()" class="xls-btn-spinner"/>
    } @else {
      <mat-icon class="xls-btn-icon">{{ icon() }}</mat-icon>
    }
    <span class="xls-btn-badge" aria-hidden="true">X</span>
  </span>

  @if (size() !== 'small') {
    <span class="xls-btn-label">{{ text() }}</span>
  }
</button>
